import { AlertTriangle, Ban, CheckCircle2, CircleDashed, Clock, Loader2, XCircle } from "lucide-react";
import type { Job, ProtectionStatus, StoragePool } from "../api/types";
import { common } from "../i18n/common";
import { useT } from "../i18n/core";
import { jobStatusTone, poolHealthTone, protectionTone, type Tone } from "../lib/status";

const toneIcon: Record<Tone, typeof CheckCircle2> = {
  ok: CheckCircle2,
  warn: AlertTriangle,
  crit: XCircle,
  idle: Ban,
  info: Loader2,
};

export function Pill({ tone, children, icon }: { tone: Tone; children: React.ReactNode; icon?: typeof CheckCircle2 }) {
  const Icon = icon ?? toneIcon[tone];
  return (
    <span className={`pill ${tone}`}>
      <Icon aria-hidden="true" />
      {children}
    </span>
  );
}

const protectionIcon: Record<ProtectionStatus, typeof CheckCircle2> = {
  protected: CheckCircle2,
  stale: Clock,
  failed: XCircle,
  never: CircleDashed,
  revoked: Ban,
};

export function ProtectionPill({ status }: { status: ProtectionStatus }) {
  const t = useT(common);
  return (
    <Pill tone={protectionTone[status]} icon={protectionIcon[status]}>
      {t.protection[status]}
    </Pill>
  );
}

export function JobPill({ status }: { status: Job["status"] }) {
  const t = useT(common);
  return <Pill tone={jobStatusTone[status]}>{t.jobStatus[status]}</Pill>;
}

export function HealthPill({ health }: { health: StoragePool["health"] }) {
  const t = useT(common);
  return <Pill tone={poolHealthTone[health]}>{t.poolHealth[health]}</Pill>;
}
